import { type ImportExamineeAnswersErrorDetails } from '../../types';

function getImportAnswerErrorMessage(constants: {
  worksheetSheetName: string;
}): Record<string, string> {
  const { worksheetSheetName } = constants;
  return {
    PROCESSING_EXAMINEES_LENGTH_NOT_MATCH: 'จำนวนรายชื่อไม่ตรงกับจำนวนผู้เข้าสอบที่ลงทะเบียน',
    DUPLICATED_CITIZEN_ID: 'พบเลขบัตรประชาชนซ้ำกันในไฟล์',
    INVALID_CITIZEN_ID_FORMAT:
      'รูปแบบเลขบัตรประชาชนไม่ถูกต้อง ต้องมีจำนวน 13 หลักและเป็นตัวเลขเท่านั้น',
    CITIZEN_ID_NOT_PRESENT_IN_EXAM_EVENT: 'ไม่พบเลขบัตรประชาชนนี้ในรอบการสอบ',
    INVALID_EXAM_PAPER_CODE: 'รหัสประจำข้อสอบไม่ถูกต้อง ต้องมีจำนวน 5 หลักและเป็นตัวเลขเท่านั้น',
    INVALID_PAPER_BASED_EXAM_DATE_FORMAT:
      // eslint-disable-next-line @cspell/spellchecker
      'รูปแบบวันที่สอบไม่ถูกต้อง กรุณาระบุวันที่สอบเป็น ตัวเลข 4 หลัก ตามรูปแบบ DDMM\nเช่น วันที่ 7 มกราคม ให้กรอก 0701',
    INVALID_PAPER_BASED_EXAM_YEAR_FORMAT:
      'รูปแบบปีที่สอบไม่ถูกต้อง กรุณาระบุปีเป็นเลข 2 หลัก (2 ตัวท้ายของปี พ.ศ.) เช่น ปี 2569 ให้กรอก 69',
    INVALID_SEAT_NUMBER_FORMAT:
      'รูปแบบเลขที่นั่งสอบไม่ถูกต้อง กรุณาระบุเลขที่นั่งเป็นเลข 3 หลัก และต้องไม่เว้นว่าง เช่น 001',
    INVALID_EXAM_ROUND_NO_FORMAT:
      'รูปแบบรหัสเฉพาะไม่ถูกต้อง กรุณาระบุรหัสเฉพาะเป็นเลข 3 หลัก และต้องไม่เว้นว่าง เช่น 001',
    INVALID_ANSWER_VALUE:
      'รูปแบบคำตอบไม่ถูกต้อง คำตอบต้องเป็นตัวเลขตั้งแต่ 1 ขึ้นไป หากไม่มีคำตอบให้เว้นว่าง',
    ANSWERS_LENGTH_NOT_MATCH_TOTAL_QUESTIONS: 'จำนวนข้อสอบในไฟล์ไม่ตรงกับชุดข้อสอบของรอบสอบนี้',
    WORKSHEET_NOT_FOUND: `ไม่พบแผ่นงานที่ระบบรองรับ กรุณาตรวจสอบว่าไฟล์มีแผ่นงานชื่อ "${worksheetSheetName}"`,
    ABSENT_EXAMINEE: 'ผู้เข้าสอบรายนี้อยู่ในสถานะ "Absent" หรือ "Canceled"',
  };
}

export function mapErrorsMessageWithTargetRows(
  errors: Record<string, ImportExamineeAnswersErrorDetails[]>,
  constants: {
    worksheetSheetName: string;
  },
) {
  const importExamineeAnswersErrorMessages = getImportAnswerErrorMessage(constants);
  const mappedErrors = Object.entries(errors).reduce<{ message: string; rows: number[] }[]>(
    (acc, [code, details]) => {
      const message = importExamineeAnswersErrorMessages[code];
      if (!message) {
        return acc;
      }

      acc.push({
        message,
        rows: details.flatMap((detail) => detail.details?.targetRows ?? []),
      });
      return acc;
    },
    [],
  );

  return mappedErrors.sort((a, b) => {
    const aIndex = Object.values(importExamineeAnswersErrorMessages).indexOf(a.message);
    const bIndex = Object.values(importExamineeAnswersErrorMessages).indexOf(b.message);
    return aIndex - bIndex;
  });
}
